export const detailTabs = [
  {
    pathname: '/CollegeDetails',
    text: 'Dashboard',
  },
  {
    pathname: '/CollegeDetailCampus',
    text: 'Campus',
  },
  {
    pathname: '/CollegeDetailPersonnel',
    text: 'Personnel',
  },
  {
    pathname: '/CollegeDetailTimetable',
    text: 'Timetable',
  },
  {
    pathname: '/CollegeDetailCalendar',
    text: 'Calendar',
  },
  {
    pathname: '/CollegeDetailJobs',
    text: 'Job List',
  },
  {
    pathname: '/CollegeDetailListings',
    text: 'Job Listings',
  },
  {
    pathname: '/FinanceSettingCollege',
    text: 'Finance Setting',
  }
]

export const updateTabActiveStatus = (pathName) => {
  detailTabs.forEach((ele) => {
    if (ele.pathname === pathName) {
      ele.active = true
    } else {
      ele.active = false
    }
  })
}
